import { useState } from 'react'

import { Spinner } from '@/components/ui/spinner'
import { useMachinesQuery } from '../hooks/useMachines'
import type { Machine } from '../types'
import { MachineCard } from './MachineCard'
import { MachineConfigSheet } from './MachineConfigSheet'

export function MachinesGrid() {
  const { data, isLoading, isError, error } = useMachinesQuery()
  const [selected, setSelected] = useState<Machine | null>(null)
  const [sheetOpen, setSheetOpen] = useState(false)

  const handleSelect = (machine: Machine) => {
    setSelected(machine)
    setSheetOpen(true)
  }

  if (isLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <Spinner className="h-8 w-8" />
      </div>
    )
  }

  if (isError) {
    return (
      <div className="p-6 text-sm text-destructive">
        {error instanceof Error ? error.message : 'Failed to load machines'}
      </div>
    )
  }

  const machines = data?.machines ?? []

  return (
    <div className="p-4">
      {machines.length === 0 ? (
        <div className="flex h-64 items-center justify-center text-sm text-muted-foreground">
          No machines registered.
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {machines.map((machine) => (
            <MachineCard
              key={machine.machine_id}
              machine={machine}
              onSelect={handleSelect}
            />
          ))}
        </div>
      )}
      <MachineConfigSheet
        machine={selected}
        open={sheetOpen}
        onOpenChange={setSheetOpen}
      />
    </div>
  )
}
